import { getCdnUrl } from './url'

export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.currentTarget
    target.onerror = null
    target.src = getCdnUrl('/_toad/images/default-product-card.png')

    const parent = target.parentNode

    if (parent instanceof HTMLPictureElement) {
        const children = Array.from(parent.children)
        children.forEach((child) => {
            if (child instanceof HTMLSourceElement) {
                child.srcset = target.src
            }
        })
    } else {
        target.onerror = null
    }
}
